var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.titleName))]),_vm._t("default"),(_vm.item.errors)?_c('core-error',{attrs:{"property":_vm.property,"errors":_vm.item.errors[_vm.property]}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }